import { render, staticRenderFns } from "./PreparationTopics.vue?vue&type=template&id=c483c41a&"
import script from "./PreparationTopics.vue?vue&type=script&lang=js&"
export * from "./PreparationTopics.vue?vue&type=script&lang=js&"
import style0 from "./PreparationTopics.vue?vue&type=style&index=0&id=c483c41a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports